const dynamicFilterList = ({
  type = 'site-listing',
  updateFilters,
  areaHierarchyDataMap,
  filters,
  picklistsMap,
  taskStatusTags,
  taskTypeTag,
  assignableUsersTags,
  taskRecurringTemplateTags,
  workOrderTypeTagMap,
  inspectionRunTags,
  inspectionTypeTagsMap,
  checkTypeTagsMap,
  hseEventsCategoriesTags,
  equipmentCategoryTags = {},
  equipmentTypeTags = {}
}) => {
  return [
    // sites
    ...siteFilterGroup({
      updateFilters,
      areaHierarchyDataMap,
      picklistsMap,
      type,
      filters,
      equipmentCategoryTags,
      equipmentTypeTags
    }),
    // equipments
    ...equipmentFilterGroup({ updateFilters, picklistsMap, type, filters }),
    // structures
    ...structureFilterGroup({ updateFilters, picklistsMap, type, filters }),
    // pipelines
    ...pipelineFilterGroup({ updateFilters, picklistsMap, type, filters, areaHierarchyDataMap }),
    // tasks
    ...taskFilterGroup({
      taskStatusTags,
      taskTypeTag,
      assignableUsersTags,
      taskRecurringTemplateTags,
      workOrderTypeTagMap,
      inspectionRunTags,
      inspectionTypeTagsMap,
      checkTypeTagsMap,
      hseEventsCategoriesTags,
      updateFilters,
      picklistsMap,
      type,
      filters,
      equipmentCategoryTags,
      equipmentTypeTags
    })
  ];
};

export default dynamicFilterList;

const filterOrder = {
  'site-listing': {
    proximity: 1,
    area: 2,
    siteType: 3,
    siteStatus: 4,

    taskType: 5,
    taskStatus: 6,
    assign: 7,
    workOrderPriority: 8,
    checkRecurrancePriority: 9,
    recurringTemplate: 10,
    workOrderType: 11,
    inspectionRun: 12,
    inspectionType: 13,
    checkType: 14,
    hseEventCategory: 15,
    dueDate: 16,
    scheduledDate: 17,
    syncedDate: 18,
    equipmentCategory: 19,
    equipmentType: 20
  },
  'equipment-listing': {
    equipmentCategory: 1,
    equipmentType: 2,
    equipmentSubType: 3,
    equipmentStatus: 4,

    proximity: 5,
    area: 6,
    siteType: 7,
    siteStatus: 8,

    taskType: 9,
    taskStatus: 10,
    assign: 11,
    workOrderPriority: 12,
    recurringTemplate: 13,
    workOrderType: 14,
    inspectionRun: 15,
    inspectionType: 16,
    checkType: 17,
    dueDate: 18,
    scheduledDate: 19,
    syncedDate: 20
  },
  'structure-listing': {
    structureType: 1,
    structureStatus: 2,

    proximity: 3,
    area: 4,
    siteType: 5,
    siteStatus: 6,

    taskType: 7,
    taskStatus: 8,
    assign: 9,
    workOrderPriority: 10,
    recurringTemplate: 11,
    workOrderType: 12,
    checkType: 13,
    dueDate: 14,
    scheduledDate: 15,
    syncedDate: 16
  },

  'pipeline-listing': {
    pipelineArea: 1,
    pipelineStatus: 2,

    taskType: 3,
    taskStatus: 4,
    assign: 5,
    workOrderPriority: 6,
    checkRecurrancePriority: 7,
    recurringTemplate: 8,
    workOrderType: 9,
    inspectionRun: 10,
    inspectionType: 11,
    checkType: 12,
    hseEventCategory: 13,
    dueDate: 14,
    scheduledDate: 15,
    syncedDate: 16
  },

  'tasks-listing': {
    taskType: 1,
    taskStatus: 2,
    assign: 3,
    workOrderPriority: 4,
    checkRecurrancePriority: 5,
    inspectionRun: 6,
    inspectionType: 7,

    workOrderType: 8,
    checkType: 9,
    hseEventCategory: 10,
    recurringTemplate: 11,
    dueDate: 12,
    scheduledDate: 13,
    createdAt: 14,

    equipmentCategory: 15,
    equipmentType: 16,

    syncedDate: 17,

    proximity: 18,
    area: 19,
    siteType: 20,
    siteStatus: 21
  }
};

const siteFilterGroup = ({ updateFilters, areaHierarchyDataMap, picklistsMap, type, filters }) => {
  return type !== 'pipeline-listing'
    ? [
        {
          key: 'proximity',
          component: 'SelectedProximityFilter',
          order: filterOrder[type]?.proximity,
          deleteChip: () => {
            updateFilters('proximity', 'value', 0);
          }
        },
        {
          key: 'area',
          tagsMap: areaHierarchyDataMap,
          component: 'SelectedCollapseableFilter1',
          order: filterOrder[type]?.area,
          deleteSelectedChip: (tag) => {
            updateFilters(
              'area',
              'value',
              filters?.area?.value?.filter((el) => el !== tag)
            );
          }
        },
        {
          key: 'siteType',
          tagsMap: picklistsMap,
          order: filterOrder[type]?.siteType,
          deleteSelectedChip: (tag) => {
            updateFilters(
              'siteType',
              'value',
              filters?.siteType?.value?.filter((el) => (picklistsMap[tag]?.key || tag) !== el)
            );
          }
        },
        {
          key: 'siteStatus',
          tagsMap: picklistsMap,
          order: filterOrder[type].siteStatus,
          deleteSelectedChip: (tag) => {
            updateFilters(
              'siteStatus',
              'value',
              filters?.siteStatus?.value?.filter((el) => (picklistsMap[tag]?.key || tag) !== el)
            );
          }
        }
      ]
    : [];
};

const taskFilterGroup = ({
  taskStatusTags,
  taskTypeTag,
  assignableUsersTags,
  taskRecurringTemplateTags,
  workOrderTypeTagMap,
  inspectionRunTags,
  inspectionTypeTagsMap,
  checkTypeTagsMap,
  hseEventsCategoriesTags,
  updateFilters,
  picklistsMap,
  type,
  filters
  // equipmentCategoryTags,
  // equipmentTypeTags
}) => {
  return [
    {
      key: 'taskType',
      tagsMap: taskTypeTag,
      order: filterOrder[type]?.taskType,
      deleteSelectedChip: (tag) => {
        updateFilters(
          'taskType',
          'value',
          filters?.taskType?.value?.filter((el) => (taskTypeTag[tag]?.key || tag) !== el)
        );
      }
    },
    {
      key: 'taskStatus',
      tagsMap: taskStatusTags || ['To do', 'In progress', 'Pending sync', 'Synced'],
      order: filterOrder[type]?.taskStatus,

      deleteSelectedChip: (tag) => {
        updateFilters(
          'taskStatus',
          'value',
          filters?.taskStatus?.value?.filter((el) => (taskStatusTags[tag]?.key || tag) !== el)
        );
      }
    },
    {
      key: 'assign',
      tagsMap: assignableUsersTags,
      order: filterOrder[type]?.assign,

      deleteSelectedChip: (tag) => {
        updateFilters(
          'assign',
          'value',
          filters?.assign?.value?.filter((el) => (assignableUsersTags[tag]?.key || tag) !== el)
        );
      }
    },
    {
      key: 'workOrderPriority',
      tagsMap: picklistsMap,
      order: filterOrder[type]?.workOrderPriority,

      deleteSelectedChip: (tag) => {
        updateFilters(
          'workOrderPriority',
          'value',
          filters?.workOrderPriority?.value?.filter((el) => (picklistsMap[tag]?.key || tag) !== el)
        );
      }
    },
    ...(type !== 'equipment-listing' && type !== 'structure-listing'
      ? [
          {
            key: 'checkRecurrancePriority',
            tagsMap: picklistsMap,
            order: filterOrder[type]?.checkRecurrancePriority,

            deleteSelectedChip: (tag) => {
              updateFilters(
                'checkRecurrancePriority',
                'value',
                filters?.checkRecurrancePriority?.value?.filter(
                  (el) => (picklistsMap[tag]?.key || tag) !== el
                )
              );
            }
          }
        ]
      : []),
    {
      key: 'recurringTemplate',
      tagsMap: taskRecurringTemplateTags,
      order: filterOrder[type]?.recurringTemplate,

      deleteSelectedChip: (tag) => {
        updateFilters(
          'recurringTemplate',
          'value',
          filters?.recurringTemplate?.value?.filter(
            (el) => (taskRecurringTemplateTags[tag]?.key || tag) !== el
          )
        );
      }
    },
    {
      key: 'workOrderType',
      tagsMap: workOrderTypeTagMap,
      order: filterOrder[type]?.workOrderType,

      deleteSelectedChip: (tag) => {
        updateFilters(
          'workOrderType',
          'value',
          filters?.workOrderType?.value?.filter(
            (el) => (workOrderTypeTagMap[tag]?.key || tag) !== el
          )
        );
      }
    },
    ...(type !== 'structure-listing'
      ? [
          {
            key: 'inspectionRun',
            tagsMap: inspectionRunTags,
            order: filterOrder[type]?.inspectionRun,

            deleteSelectedChip: (tag) => {
              updateFilters(
                'inspectionRun',
                'value',
                filters?.inspectionRun?.value?.filter(
                  (el) => (inspectionRunTags[tag]?.key || tag) !== el
                )
              );
            }
          }
        ]
      : []),
    ...(type !== 'structure-listing'
      ? [
          {
            key: 'inspectionType',
            tagsMap: inspectionTypeTagsMap,
            order: filterOrder[type]?.inspectionType,

            deleteSelectedChip: (tag) => {
              updateFilters(
                'inspectionType',
                'value',
                filters?.inspectionType?.value?.filter(
                  (el) => (inspectionTypeTagsMap[tag]?.key || tag) !== el
                )
              );
            }
          }
        ]
      : []),
    {
      key: 'checkType',
      tagsMap: checkTypeTagsMap,
      order: filterOrder[type]?.checkType,

      deleteSelectedChip: (tag) => {
        updateFilters(
          'checkType',
          'value',
          filters?.checkType?.value?.filter((el) => (checkTypeTagsMap[tag]?.key || tag) !== el)
        );
      }
    },
    ...(type !== 'equipment-listing' && type !== 'structure-listing'
      ? [
          {
            key: 'hseEventCategory',
            tagsMap: hseEventsCategoriesTags,
            order: filterOrder[type]?.hseEventCategory,

            deleteSelectedChip: (tag) => {
              updateFilters(
                'hseEventCategory',
                'value',
                filters?.hseEventCategory?.value?.filter(
                  (el) => (hseEventsCategoriesTags[tag]?.key || tag) !== el
                )
              );
            }
          }
        ]
      : []),
    {
      key: 'dueDate',
      component: 'SelectedDueDateFilter',
      order: filterOrder[type]?.dueDate,

      deleteSelectedChip: () => {
        updateFilters('dueDate', 'value', '');
      }
    },
    {
      key: 'scheduledDate',
      component: 'SelectedDueDateFilter',
      order: filterOrder[type]?.scheduledDate,

      deleteSelectedChip: () => {
        updateFilters('scheduledDate', 'value', '');
      }
    },
    ...(type === 'tasks-listing'
      ? [
          {
            key: 'createdAt',
            component: 'SelectedDueDateFilter',
            order: filterOrder[type]?.createdAt,

            deleteSelectedChip: () => {
              updateFilters('createdAt', 'value', '');
            }
          }
        ]
      : []),

    {
      key: 'syncedDate',
      component: 'SelectedDueDateFilter',
      order: filterOrder[type]?.syncedDate,

      deleteSelectedChip: () => {
        updateFilters('syncedDate', 'value', '');
      }
    }
  ];
};

const equipmentFilterGroup = ({ picklistsMap, updateFilters, filters, type }) => {
  return type === 'equipment-listing'
    ? [
        {
          key: 'equipmentCategory',
          tagsMap: picklistsMap,
          order: filterOrder[type]?.equipmentCategory,

          deleteSelectedChip: (tag) => {
            updateFilters(
              'equipmentCategory',
              'value',
              filters?.equipmentCategory?.value?.filter(
                (el) => (picklistsMap[tag]?.key || tag) !== el
              )
            );
          }
        },
        {
          key: 'equipmentType',
          tagsMap: picklistsMap,
          order: filterOrder[type]?.equipmentType,

          deleteSelectedChip: (tag) => {
            updateFilters(
              'equipmentType',
              'value',
              filters?.equipmentType?.value?.filter((el) => (picklistsMap[tag]?.key || tag) !== el)
            );
          }
        },
        {
          key: 'equipmentSubType',
          tagsMap: picklistsMap,
          order: filterOrder[type]?.equipmentSubType,

          deleteSelectedChip: (tag) => {
            updateFilters(
              'equipmentSubType',
              'value',
              filters?.equipmentSubType?.value?.filter(
                (el) => (picklistsMap[tag]?.key || tag) !== el
              )
            );
          }
        },
        {
          key: 'equipmentStatus',
          tagsMap: picklistsMap,
          order: filterOrder[type]?.equipmentStatus,

          deleteSelectedChip: (tag) => {
            updateFilters(
              'equipmentStatus',
              'value',
              filters?.equipmentStatus?.value?.filter(
                (el) => (picklistsMap[tag]?.key || tag) !== el
              )
            );
          }
        }
      ]
    : type === 'tasks-listing' || type === 'site-listing'
    ? [
        {
          key: 'equipmentCategory',
          tagsMap: picklistsMap,
          order: filterOrder[type]?.equipmentCategory,
          deleteSelectedChip: (tag) => {
            updateFilters(
              'equipmentCategory',
              'value',
              filters?.equipmentCategory?.value?.filter(
                (el) => (picklistsMap[tag]?.key || tag) !== el
              )
            );
          }
        },
        {
          key: 'equipmentType',
          tagsMap: picklistsMap,
          order: filterOrder[type]?.equipmentType,
          deleteSelectedChip: (tag) => {
            updateFilters(
              'equipmentType',
              'value',
              filters?.equipmentType?.value?.filter((el) => (picklistsMap[tag]?.key || tag) !== el)
            );
          }
        }
      ]
    : [];
};

const structureFilterGroup = ({ picklistsMap, updateFilters, filters, type }) => {
  return type === 'structure-listing'
    ? [
        {
          key: 'structureType',
          tagsMap: picklistsMap,
          order: filterOrder[type]?.structureType,

          deleteSelectedChip: (tag) => {
            updateFilters(
              'structureType',
              'value',
              filters?.structureType?.value?.filter((el) => (picklistsMap[tag]?.key || tag) !== el)
            );
          }
        },
        {
          key: 'structureStatus',
          tagsMap: picklistsMap,
          order: filterOrder[type]?.structureStatus,
          deleteSelectedChip: (tag) => {
            updateFilters(
              'structureStatus',
              'value',
              filters?.structureStatus?.value?.filter(
                (el) => (picklistsMap[tag]?.key || tag) !== el
              )
            );
          }
        }
      ]
    : [];
};

const pipelineFilterGroup = ({
  picklistsMap,
  updateFilters,
  filters,
  type,
  areaHierarchyDataMap
}) => {
  return type === 'pipeline-listing'
    ? [
        {
          key: 'pipelineArea',
          tagsMap: areaHierarchyDataMap,
          component: 'SelectedCollapseableFilter1',
          order: filterOrder[type]?.pipelineArea,

          deleteSelectedChip: (tag) => {
            updateFilters(
              'pipelineArea',
              'value',
              filters?.pipelineArea?.value?.filter((el) => (picklistsMap[tag]?.key || tag) !== el)
            );
          }
        },

        {
          key: 'pipelineStatus',
          tagsMap: picklistsMap,
          order: filterOrder[type]?.pipelineStatus,
          deleteSelectedChip: (tag) => {
            updateFilters(
              'pipelineStatus',
              'value',
              filters?.pipelineStatus?.value?.filter((el) => (picklistsMap[tag]?.key || tag) !== el)
            );
          }
        }
      ]
    : [];
};

export const getCountOnEachFilterObject = ({ filters, filtersCount }) => {
  const count =
    filtersCount > 0
      ? Object.keys(filters).reduce((acc, curr) => {
          if (
            typeof filters[curr]?.value !== 'string' &&
            filters[curr]?.value?.length > 0 &&
            filters[curr]?.selected !== 'range'
          ) {
            return acc + filters[curr].value.length;
          } else if (
            filters[curr]?.value > 0 ||
            (typeof filters[curr]?.value === 'string' && filters[curr].value) ||
            filters[curr]?.value?.length > 0
          ) {
            return acc + 1;
          } else {
            return acc;
          }
        }, 0)
      : 0;
  return count;
};
